import React from 'react';

const About = () => {
  return (
    <div data-testid="about-page" className="page-transition">
      {/* Hero Section */}
      <section className="pt-32 pb-20 sm:pt-40 sm:pb-28">
        <div className="container-main">
          <div className="max-w-4xl">
            <p className="label-text mb-6 animate-fade-in">About Us</p>
            <h1 className="heading-1 mb-8 animate-slide-up">
              Decades of real-world
              <br />
              operating experience.
              <br />
              <span className="text-gray-400">Enhanced by AI.</span>
            </h1>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="pb-20 sm:pb-28">
        <div className="container-main">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-16">
            {/* Left Column - Image */}
            <div className="lg:col-span-5">
              <div className="aspect-[4/5] overflow-hidden sticky top-32">
                <img
                  src="https://images.pexels.com/photos/7413935/pexels-photo-7413935.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
                  alt="Professional team"
                  className="w-full h-full object-cover"
                  data-testid="about-image"
                />
              </div>
            </div>

            {/* Right Column - Content */}
            <div className="lg:col-span-7 space-y-12">
              <div data-testid="about-intro">
                <h2 className="heading-2 mb-6">Who We Are</h2>
                <p className="body-text text-lg mb-6">
                  Dorsey and Associates is an experienced consulting firm that helps
                  organizations improve performance using practical AI and proven
                  operational expertise.
                </p>
                <p className="body-text">
                  We're not a tech company. We're not an AI startup. We're seasoned
                  operators who understand that the most powerful tool in any
                  organization is good judgment — and that AI can make that judgment
                  sharper and faster.
                </p>
              </div>

              <div data-testid="about-evolution">
                <h2 className="heading-2 mb-6">Our Evolution</h2>
                <p className="body-text mb-6">
                  For years, we've helped companies navigate complex challenges using
                  structured thinking, deep industry experience, and a relentless focus
                  on execution. Today, we've evolved — integrating modern AI tools into
                  our work to deliver even better results.
                </p>
                <p className="body-text">
                  This isn't a pivot. It's a natural evolution. AI allows us to analyze
                  faster, identify patterns more clearly, and help our clients make
                  better decisions with greater confidence.
                </p>
              </div>

              <div data-testid="about-philosophy">
                <h2 className="heading-2 mb-6">Our Philosophy</h2>
                <div className="bg-gray-50 p-8 sm:p-12 border-l-4 border-slate-900">
                  <p
                    className="text-2xl sm:text-3xl font-medium tracking-tight text-slate-900 mb-4"
                    style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}
                  >
                    "We use AI as a tool to enhance our work — not replace judgment."
                  </p>
                  <p className="body-text">
                    Technology should serve strategy, not the other way around. We bring
                    the experience to know what matters, and we use AI to get there faster.
                  </p>
                </div>
              </div>

              <div data-testid="about-values">
                <h2 className="heading-2 mb-6">What We Believe</h2>
                <div className="space-y-6">
                  <div className="flex gap-4">
                    <span className="text-4xl font-bold text-gray-200">01</span>
                    <div>
                      <h3 className="heading-3 mb-2">Results Over Reports</h3>
                      <p className="body-text">
                        We measure success by outcomes, not deliverables. Our job is to
                        help you execute, not to create more reading material.
                      </p>
                    </div>
                  </div>
                  <div className="flex gap-4">
                    <span className="text-4xl font-bold text-gray-200">02</span>
                    <div>
                      <h3 className="heading-3 mb-2">Experience Matters</h3>
                      <p className="body-text">
                        There's no substitute for having done the work. Our team brings
                        decades of hands-on operating experience across industries.
                      </p>
                    </div>
                  </div>
                  <div className="flex gap-4">
                    <span className="text-4xl font-bold text-gray-200">03</span>
                    <div>
                      <h3 className="heading-3 mb-2">Clarity Over Complexity</h3>
                      <p className="body-text">
                        The best strategies are simple enough to explain and execute.
                        We cut through noise to find what actually matters.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
